// THIS FILE IS AUTOGENERATED

export interface Version {
  commit: string;
  version: string;
  app: string;
}

export const version = {
  app: "myqq",
  commit: "b0e17bd59278fdac33a2bcb1c06e7a074c7ae7a3",
  version: "1.124.0",
};
